import { css, styled } from 'utils/styles';
import { Flex } from 'components/common';

export const ModalFooter = styled(Flex)(
	({ theme: { space } }) => css`
		margin-top: ${space.xlarge};
		gap: ${space.medium};
	`
);
